import { render } from "./featuresSection.vue?vue&type=template&id=2300792f"
import script from "./featuresSection.vue?vue&type=script&lang=js"
export * from "./featuresSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__